export const AttributeKinds = {
  DECLINED: 'declined',
  LIMITS: 'limits',
  DEDUCTIBLE: 'deductible',
  MODIFIER: '_modifier',
} as const;

export type AttributeKind = (typeof AttributeKinds)[keyof typeof AttributeKinds];
